const names = {
  "checkout-fi": "Paytrail",
  "stripe-apple-pay": "Stripe Apple/Google Pay",
  "stripe-google-pay": "Stripe Apple/Google Pay",
  // Crowded inline siblings. Values avoid literal dashes because some consumers
  // (e.g. gatewayPlate) run .replaceAll("-", " ") on the resolved name.
  "crowded-digital-wallet": "Crowded Digital Wallet",
  "crowded-ach": "Crowded ACH",
};

export function getAltNames(gatewayKey) {
  return names[gatewayKey];
}
